

import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Avatar, Breadcrumb, Layout, Menu, message } from "antd";
import { MdDashboard, MdOutlineSupervisedUserCircle } from "react-icons/md";
import { BellOutlined, BuildOutlined, HomeOutlined, LogoutOutlined, MessageOutlined, RestTwoTone, UserOutlined } from "@ant-design/icons";
import { TbCategoryPlus } from "react-icons/tb";
import { VscRequestChanges, VscSymbolProperty } from "react-icons/vsc";
import { GrServices } from "react-icons/gr";
import { Header } from "antd/es/layout/layout";
import { BiBuildingHouse, BiPhotoAlbum } from "react-icons/bi";
import { FaClipboardList, FaPlusCircle, FaUserPlus } from "react-icons/fa";

const { Sider, Content } = Layout;
const { SubMenu } = Menu;

const BasicLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("");
  const [openKeys, setOpenKeys] = useState([]);
  const parm = useLocation();
  const trimRoute = parm.pathname.split("/");
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      window.innerWidth <= 600 ? setCollapsed(true) : setCollapsed(false);
    };
    window.addEventListener("resize", handleResize);
    const stored = localStorage.getItem("selected");
    if (stored) {
      setSelectedMenu(stored);
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem("selected", selectedMenu);
  }, [selectedMenu]);

  function getlogout() {
    localStorage.clear();
    navigate("/admin");
    message.success("Admin Logged Out Successfully");
  }

  const layoutStyle = {
    borderRadius: 8,
    overflow: "hidden",
  };
  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };
  const handleMenuClick = (key, path) => {
    setSelectedMenu(key);

    if (key.startsWith("plans")) {
      setOpenKeys(["plans"]);
    } else {
      setOpenKeys([]);
    }

    navigate(path);
  };

  return (
    <Layout style={layoutStyle} className="min-h-screen sidebar bg-[#edf2f9]">
      {/* 🟢 FIXED: Instant click activation & sticky red on open-hover */}
      <style>{`
        /* 1. Default Style (Normal Black Text and Icons) */
        .ant-menu-inline .ant-menu-item,
        .ant-menu-inline .ant-menu-submenu-title {
          color: #000000 !important;
        }
        .ant-menu-inline .ant-menu-item .ant-menu-item-icon,
        .ant-menu-inline .ant-menu-submenu-title .ant-menu-item-icon,
        .ant-menu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {
          color: #bc2025 !important;
        }

        /* 2. Hover Style (Sirf tabhi chalega jab menu closed/normal ho) */
        .ant-menu-inline .ant-menu-item:hover,
        .ant-menu-inline .ant-menu-submenu-title:hover {
          background-color: #ffeef0 !important;
          color: #000000 !important;
        }
        .ant-menu-inline .ant-menu-item:hover .ant-menu-item-icon,
        .ant-menu-inline .ant-menu-submenu-title:hover .ant-menu-item-icon,
        .ant-menu-inline .ant-menu-submenu-title:hover .ant-menu-submenu-arrow {
          color: #bc2025 !important;
        }

        /* 3. Normal Items Clicked / Active State (Solid Red with White Text) */
        .ant-menu-inline .ant-menu-item.ant-menu-item-selected {
          background-color: #bc2025 !important; 
          color: #ffffff !important;
        }
        .ant-menu-inline .ant-menu-item.ant-menu-item-selected .ant-menu-item-icon {
          color: #ffffff !important;
        }

        /* 4. 🔴 FIXED: Plan Management Click & Open State (Instant Solid Red & Sticky on Hover) */
        .ant-menu-submenu-open > .ant-menu-submenu-title,
        .ant-menu-submenu-selected > .ant-menu-submenu-title,
        .ant-menu-submenu-open > .ant-menu-submenu-title:hover, 
        .ant-menu-submenu-selected > .ant-menu-submenu-title:hover,
        .ant-menu-submenu-title:active { 
          background-color: #bc2025 !important; /* Click karte hi instant aur hover karne par bhi hamesha RED */
          color: #ffffff !important; /* White Text */
        }
        
        .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-item-icon,
        .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow,
        .ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-item-icon,
        .ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-arrow,
        .ant-menu-submenu-open > .ant-menu-submenu-title:hover .ant-menu-item-icon,
        .ant-menu-submenu-open > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow {
          color: #ffffff !important; /* Icons/Arrows hamesha white rahenge open mein */
        }
        
        /* Inner Sub-items container padding reset so background fits perfectly */
        .ant-menu-inline .ant-menu-submenu-title {
          margin-top: 4px !important;
          margin-bottom: 4px !important;
        }
      `}</style>

      <Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "fixed",
          width: "100%",
          top: "0",
          zIndex: "1",
        }}
      >
        <div>
          <p className="font-bold text-lg font-poppins">Restaurant Management</p>
        </div>
        <div>
          <LogoutOutlined onClick={() => getlogout()} style={{ fontSize: "20px", cursor: "pointer", marginLeft: "15px" }} />
        </div>
      </Header>
      <Layout>
        <Sider style={{ position: "fixed" }} width="15%" className="h-[100vh] z-10 text-center top-16" collapsible collapsed={collapsed} onCollapse={() => setCollapsed(!collapsed)}>
          <Menu mode="inline" className="text-base pb-24 font-inter" selectedKeys={[selectedMenu]} openKeys={openKeys} onOpenChange={onOpenChange}>
            {/* Dashboard */}
            <Menu.Item key="1" icon={<MdDashboard />} onClick={() => handleMenuClick("1", "/dashboard")}>
              Dashboard
            </Menu.Item>

            {/* Vendors */}
            <Menu.Item key="2" icon={<MdOutlineSupervisedUserCircle />} onClick={() => handleMenuClick("2", "/vendorsDetails")}>
              Vendors
            </Menu.Item>

            {/* Category Details */}
            <Menu.Item key="4" icon={<TbCategoryPlus />} onClick={() => handleMenuClick("4", "/categoryList")}>
              Category Details
            </Menu.Item>

            {/* Order List */}
            <Menu.Item key="5" icon={<VscRequestChanges />} onClick={() => handleMenuClick("5", "/orderlist")}>
              Order List
            </Menu.Item>

            {/* Restro List */}
            <Menu.Item key="6" icon={<BiBuildingHouse />} onClick={() => handleMenuClick("6", "/restroList")}>
              Restro List
            </Menu.Item>

            {/* Food Menu */}
            <Menu.Item key="7" icon={<BiPhotoAlbum />} onClick={() => handleMenuClick("7", "/menu")}>
              Food Menu
            </Menu.Item>
            <Menu.Item key="8" icon={<FaClipboardList />} onClick={() => handleMenuClick("8", "/plans")}>
              Plan Management
            </Menu.Item>

            {/* Sign Out */}
            <Menu.Item
              key="9"
              icon={<LogoutOutlined />}
              onClick={() => {
                setSelectedMenu("8");
                setOpenKeys([]);
                getlogout();
              }}
            >
              Sign Out
            </Menu.Item>
          </Menu>
        </Sider>
        {collapsed ? (
          <Content className="min-h-screen mt-16 ml-24 relative p-4">{children}</Content>
        ) : (
          <Content
            className="min-h-screen relative p-4"
            style={{
              margin: "64px 0 0 15%",
            }}
          >
            {children}
          </Content>
        )}
      </Layout>
    </Layout>
  );
};

export default BasicLayout;